import ErrorIcon from '@mui/icons-material/Error';
import { Typography, useTheme, IconButton } from '@mui/material';
import { Alert } from '@mui/material';

import { Icon } from '@verantos-dev/shared-components';

interface ErrorAlertCardProps {
  errorMessage: string;
  onDismiss: () => void;
}

export const ErrorAlertCard = ({ errorMessage, onDismiss }: ErrorAlertCardProps) => {
  const theme = useTheme();
  if (!errorMessage) return null;
  return (
    <Alert
      severity="error"
      iconMapping={{
        error: <ErrorIcon sx={{ width: 22, height: 22 }} />,
      }}
      sx={{
        border: '1px solid',
        borderColor: 'error.main',
        alignItems: 'center',
        maxHeight: '140px',
        overflow: 'scroll',
        backgroundColor: theme.palette.red[50],
        width: '100%',
        '& .MuiAlert-message': {
          width: '100%',
          flex: 1,
          display: 'flex',
          justifyContent: 'space-between',
          gap: theme.spacing(1),
        },
      }}
    >
      <Typography variant="body2">{errorMessage}</Typography>
      <IconButton size="small" onClick={onDismiss} sx={{ mr: theme.spacing(1) }}>
        <Icon icon="clear" id="dismiss-error-icon" width={12} height={12} />
      </IconButton>
    </Alert>
  );
};
